import { SidebarPortal } from '@plone/volto/components';
import { Sidebar } from './Sidebar';
import { View } from './View';

export const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  return (
    <>
      <View {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <Sidebar {...props} data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};
